import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alignContent", "alignItems", "children", "direction", "flexAuto", "flexNone", "inline", "itemAuto", "itemNone", "justifyContent", "reverse", "spacing", "wrap"];

/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import { getChildrenElements, wrapElementWithComponent } from '@flowio/react-helpers';
import React from 'react';
import BoxItem from './BoxItem';

var boxSpacingToPixels = function boxSpacingToPixels(spacing) {
  switch (spacing) {
    case 'extraLoose':
      return '16px';

    case 'loose':
      return '12px';

    case 'tight':
      return '8px';

    case 'extraTight':
      return '4px';

    default:
      return '0px';
  }
};

var getBoxSpacing = function getBoxSpacing(spacing, direction, reverse, theme) {
  var pixels = boxSpacingToPixels(spacing);

  switch (direction) {
    case 'column':
      return reverse ? {
        marginBottom: pixels
      } : {
        marginTop: pixels
      };

    case 'row':
    default:
      {
        switch (theme.direction) {
          case 'ltr':
            return reverse ? {
              marginRight: pixels,
              marginLeft: undefined,
              marginInlineEnd: pixels
            } : {
              marginLeft: pixels,
              marginRight: undefined,
              marginInlineStart: pixels
            };

          default:
            return reverse ? {
              marginLeft: pixels,
              marginRight: undefined,
              marginInlineEnd: pixels
            } : {
              marginRight: pixels,
              marginLeft: undefined,
              marginInlineStart: pixels
            };
        }
      }
  }
};

var Box = function Box(_ref) {
  var _ref$alignContent = _ref.alignContent,
      alignContent = _ref$alignContent === void 0 ? 'stretch' : _ref$alignContent,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? 'stretch' : _ref$alignItems,
      children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'row' : _ref$direction,
      _ref$flexAuto = _ref.flexAuto,
      flexAuto = _ref$flexAuto === void 0 ? false : _ref$flexAuto,
      _ref$flexNone = _ref.flexNone,
      flexNone = _ref$flexNone === void 0 ? false : _ref$flexNone,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$itemAuto = _ref.itemAuto,
      itemAuto = _ref$itemAuto === void 0 ? false : _ref$itemAuto,
      _ref$itemNone = _ref.itemNone,
      itemNone = _ref$itemNone === void 0 ? false : _ref$itemNone,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? 'start' : _ref$justifyContent,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var styles = {
    display: 'flex',
    '& > div:not(:first-of-type)': getBoxSpacing(spacing, direction, reverse, theme)
  };

  if (inline) {
    styles.display = 'inline-flex';
  }

  if (flexAuto) {
    styles.flex = '1 1 auto';
  } else if (flexNone) {
    styles.flex = '0 0 auto';
  }

  if (direction === 'column') {
    styles.flexDirection = reverse ? 'column-reverse' : 'column';
  } else if (direction === 'row') {
    styles.flexDirection = reverse ? 'row-reverse' : 'row';
  }

  if (alignContent === 'start') {
    styles.alignContent = 'flex-start';
  } else if (alignContent === 'end') {
    styles.alignContent = 'flex-end';
  } else if (alignContent === 'between') {
    styles.alignContent = 'space-between';
  } else if (alignContent === 'around') {
    styles.alignContent = 'space-around';
  } else {
    styles.alignContent = alignContent;
  }

  if (alignItems === 'start') {
    styles.alignItems = 'flex-start';
  } else if (alignItems === 'end') {
    styles.alignItems = 'flex-end';
  } else {
    styles.alignItems = alignItems;
  }

  if (justifyContent === 'start') {
    styles.justifyContent = 'flex-start';
  } else if (justifyContent === 'end') {
    styles.justifyContent = 'flex-end';
  } else if (justifyContent === 'around') {
    styles.justifyContent = 'space-around';
  } else if (justifyContent === 'between') {
    styles.justifyContent = 'space-between';
  } else {
    styles.justifyContent = justifyContent;
  }

  if (wrap) {
    styles.flexWrap = 'wrap';
  }

  return jsx("div", _extends({}, unhandledProps, {
    css: /*#__PURE__*/css(styles, process.env.NODE_ENV === "production" ? "" : ";label:Box;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }), getChildrenElements(children).map(function (element, index) {
    return wrapElementWithComponent(element, BoxItem, {
      flexAuto: itemAuto,
      flexNone: itemNone,
      key: index
    });
  }));
};

Box.displayName = 'Box';
export default Box;